import React, { Component } from 'react'

class AddressView extends Component {

  static defaultProps = {
    isEmployer: false
  }

  render() {
    let address = this.props.addressInfo;
    let titleApartment = this.props.titleApartment;
    let isEmployer = this.props.isEmployer;
    let postalCode = address.postalCode;
    if (!address) {
      return null;
    }

    return (
      <div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Страна</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{address.country?.label || address.country}</p>
                </div>
              </div>
            </div>
          </div>
          {address.region && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Область</label>
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  <p>{address.region?.value || address.region}</p>
                </div>
              </div>
            </div>
          </div>}
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Населенный пункт</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{address.cityType} {address.city?.name || address.city}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Улица</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{address.streetType === '-' ? '' : address.streetType} {address.street?.name || address.street}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Дом, корпус</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>д. {address.house} {address.building ? `к. ${address.building}` : ""}</p>
                </div>
              </div>
            </div>
          </div>
          {address.apartment && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">
                {titleApartment}
              </label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{address.apartment}</p>
                </div>
              </div>
            </div>
          </div>}
        </div>
        <div className="form-row">
        {!isEmployer && <div className="form-row-item">
            <div className="form-element">
              <div className="form-element-data date">
                <div className="form-element-data-text">
                  {address.active ? <span className="label label-success">Активен</span> :
                    <span className="label label-gray">Неактивен</span>}
                </div>
              </div>
            </div>
          </div>}
          {postalCode && <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="#">Индекс</label>
              <div className="form-element-data">
                <div className="form-element-data-text">
                  <p>{postalCode}</p>
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    )
  }
}

export default AddressView
